export const ACTION_MENU_ID = 'lexical-action-menu';
export const ACTION_SIDEBAR_ID = 'action-sidebar';
